import { SUPPORTED_USER_ROLES } from '@shared/constants/SupportedUserRoles';
import { type UserRole } from '@mobx/interfaces';

const TRUSTED_ROLES = ['CHAIRMAN_TRUSTED', 'CHAIRMAN_TRUSTED_READONLY'];

/**
 * Роли, которые пользователь может выбрать в кабинете (экран `/auth/select-role`).
 *
 * ЗАЧЕМ ВЫНЕСЕНО (дефект «сброс роли на ABONENT после очистки сессии»):
 * раньше эта логика жила только внутри `SelectRoleViewModel.processRoles`. Теперь тот же самый
 * список нужен ещё в трёх местах — гварду «роль выбрана» (автовыбор единственной роли),
 * пункту «Сменить роль» в меню аватара и карточке роли в боковом меню. Чтобы все они считали
 * «сколько ролей можно выбрать» ОДИНАКОВО с экраном выбора, правило вынесено в одну функцию.
 * Поведение экрана выбора роли не изменилось — он вызывает эту же функцию.
 *
 * ПРАВИЛА (перенесены без изменений):
 * 1. Оставляем только поддерживаемые кабинетом роли (`SUPPORTED_USER_ROLES`).
 * 2. Есть CHAIRMAN_TRUSTED / CHAIRMAN_TRUSTED_READONLY, но нет CHAIRMAN — добавляем
 *    виртуальную роль «Доверенный» с кодом найденной trusted-роли.
 * 3. Есть и CHAIRMAN, и trusted-роль — trusted «поглощается», показываем только CHAIRMAN.
 */
export const getSelectableRoles = (roles: UserRole[] | null | undefined): UserRole[] => {
  if (!roles?.length) return [];

  const hasChairman = roles.some((r) => r.role === 'CHAIRMAN');
  const trustedRole = roles.find((r) => TRUSTED_ROLES.includes(r.role));

  // Фильтруем стандартные роли
  let filteredRoles = roles.filter((r) => SUPPORTED_USER_ROLES.includes(r.role));

  // Если есть CHAIRMAN_TRUSTED или CHAIRMAN_TRUSTED_READONLY, но нет CHAIRMAN
  // Добавляем виртуальную роль "Доверенный"
  if (!hasChairman && trustedRole) {
    const trustedVirtualRole: UserRole = {
      nameRu: 'Доверенный',
      nameKz: 'Сенімді',
      role: trustedRole.role
    };
    filteredRoles = [...filteredRoles, trustedVirtualRole];
  }

  // Если есть и CHAIRMAN и CHAIRMAN_TRUSTED - CHAIRMAN_TRUSTED "поглощается"
  // (ничего дополнительного не добавляем, показываем только CHAIRMAN)

  return filteredRoles;
};
